export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/refund-badge.dfc40ebd.svg","height":48,"width":49};